import $ from 'jquery';

import rimg from 'rimg-shopify';

export default class Instagram {
  constructor($el) {
    this.$photoContainer = null;
    this.$errorContainer = null;
    this.rimg = null;
    this.photos = [];
    this._renderPhotos = this._renderPhotos.bind(this);

    if (!$el.length) { return; }

    this.$photoContainer = $el.find('[data-instagram-photos]');
    this.accessToken = $el.find('[data-instagram-token]').attr('data-instagram-token');
    this.accessTokenError = $el.find('[data-instagram-error]').attr('data-instagram-error');

    rimg.instance.track(this.$photoContainer[0]);

    if (this.accessToken.length > 0) {
      this._getPhotos();
      this.$photoContainer.on('rimg:enter', () => this._renderPhotos());
    } else {
      this._hasError(false);
    }
  }

  unload() {
    rimg.shopify.instance.track(this.$photoContainer[0]);
  }

  _getPhotos(callback = null) {
    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${this.accessToken}&count=6&callback=`;

    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url,

      success: (response) => {
        if (response.meta.code === 200) {
          this.$photoContainer.html('');
          this.photos = response.data;
          if (typeof callback === 'function') {
            callback();
          }
        } else {
          this._hasError(response);
          this._errorOverlay();
        }
      },

      error: response => this._hasError(response),
    });
  }

  _renderPhotos() {
    if (!this.photos.length) {
      this._getPhotos(this._renderPhotos);
    }

    this.photos.forEach((photo) => {
      const image = photo.images.standard_resolution;
      const scale = image.width > image.height ? 'y' : 'x';
      this.$photoContainer.append(`\
        <div class="instagram-photo">
          <a
              class="instagram-link"
              target="_blank"
              href="${photo.link}"
          >
              <img
                  class="
                      instagram-image
                      instagram-image-scale-${scale}
                  "
                  src="${image.url}"
              />
          </a>
        </div>\
      `);
    });
  }

  _errorOverlay() {
    if (this.$photoContainer.find('[data-instagram-errror]').length) { return; }

    this.$photoContainer.append(`<div class="instagram-error" data-instagram-error>${this.accessTokenError}</div>`);
    this.$errorContainer = this.$photoContainer.find('[data-instagram-errror]');
  }

  _hasError(response) {
    if (response) { console.log(`Instagram error: ${response.meta.error_message}`); }
  }
}
